// `application` sub-context shared between the initial LDProvider context and
// any subsequent client.identify() call, so flag rules that target
// `application.key` continue to match after login/identification.
export const LD_APPLICATION_CONTEXT = { key: 'marketplace' };

// Shared by every browser user, guest or logged in, so /sdk/evalx/ context URLs are identical across
// visitors and cacheable at the edge (ECOMM-13651). Per-user targeting needs an explicit opt-in key.
export const LD_ANONYMOUS_USER_KEY = 'anonymous';
